import React from "react";
import { Button } from "@/components/ui/button";
import { Loader2, Send } from "lucide-react";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";
interface ReadingPlanFormProps {
  topic: string;
  days: number;
  isLoading: boolean;
  onTopicChange: (value: string) => void;
  onDaysChange: (value: number) => void;
  onSubmit: (e: React.FormEvent) => Promise<void>;
}
const ReadingPlanForm: React.FC<ReadingPlanFormProps> = ({
  topic,
  days,
  isLoading,
  onTopicChange,
  onDaysChange,
  onSubmit
}) => {
  return <form onSubmit={onSubmit} className="max-w-2xl mx-auto">
      <div className="flex flex-col sm:flex-row gap-3">
        <input type="text" placeholder="Ex. Faith, Love, Patience, etc..." value={topic} onChange={e => onTopicChange(e.target.value)} className="flex-1 h-12 px-4 rounded-lg bg-gray-50 border border-gray-200 focus:outline-none focus:ring-2 focus:ring-heaven-gold/30 focus:border-transparent py-[23px]" />
        <div className="flex flex-col sm:flex-row gap-3 w-full sm:w-auto">
          <Select value={days.toString()} onValueChange={value => onDaysChange(parseInt(value))} disabled={isLoading}>
            <SelectTrigger className="w-full sm:w-32 h-12 bg-gray-50 border-gray-200">
              <SelectValue placeholder="Days" />
            </SelectTrigger>
            <SelectContent>
              <SelectItem value="7">7 Days</SelectItem>
              <SelectItem value="10">10 Days</SelectItem>
            </SelectContent>
          </Select>
          <Button type="submit" className="bg-black text-white hover:bg-gray-800 h-12 px-6 rounded-lg w-full sm:w-auto" disabled={isLoading}>
            {isLoading ? <>
                <Loader2 className="mr-2 h-4 w-4 animate-spin" />
                Creating...
              </> : <>
                <Send className="mr-2 h-4 w-4" />
                Generate
              </>}
          </Button>
        </div>
      </div>
    </form>;
};
export default ReadingPlanForm;